import {firebase} from '../firebase/firebase';

export const authTypes = {
    LOGIN: "authorize/LOGGING_IN",
    SIGNOUT: "authorize/DEAUTHORIZE",
    ADMINSESSION: "authorize/ADMIN_IN",
    ADMINSIGNOUT: "authorize/ADMIN_DEAUTHORIZE",
    COMPANYSESSION: "authorize/COMPANY_IN",
    COMPANYSIGNOUT: "authorize/COMPANY_DEAUTHORIZE",
    ISABLETO: "authorize/REQUEST_VACANCY",
    SILENCETRIGGER: "authorize/SILENCE_TRIGGER"
};

export const login = (uid, claim) => ({
    type: authTypes.LOGIN,
    uid, claim
});
export const isAbleToGet = (isAbleTo) => ({
    type: authTypes.ISABLETO,
    isAbleTo
})
export const adminLogin = (uid, claim) => ({
    type: authTypes.ADMINSESSION,
    uid,claim
});

export const companyLogin = (uid, claim) => ({
    type: authTypes.COMPANYSESSION,
    uid,claim
});

export const logout = () => ({
    type: authTypes.SIGNOUT
});

export const adminLogout = () => ({
    type: authTypes.ADMINSIGNOUT
});
export const companyLogout = () => ({
    type: authTypes.COMPANYSIGNOUT
});

export const startLogout = () => {
    return () => {
        return firebase.auth().signOut();
    };
};